<template>
  <div class="container text-center container-vende-tu-auto">

    <div class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center">
      <img class="step-desktop" src="../assets/imgs/desktop/desktop-VTA-valoracion-modificar01.png" alt="AUTOCOM" />
      <img class="step-tablet" src="../assets/imgs/tablet/tablet-VTA-VALORACION-MODIFICAR01.png" alt="AUTOCOM" />
      <img class="step-mobile" src="../assets/imgs/mobile/MOBILE-VTA-VALORACION-MODIFICAR01.png" alt="AUTOCOM" />
    </div>

    <div class="container container-info ">
      <div class="container-vende-view">
        <div class="content-va">

          <!-- Oferta -->
          <div v-if="this.oferta === true" class="row text-center info-auto-oferta">

            <div class="oferta-tituloinfo">
              <h4 class="titulo-reagendamiento"> Esta es tu oferta y los datos del agendamiento para la inspección.</h4>
            </div>
            <div class="marcaModeloAño oferta-infoauto">{{ año }} <span class="black">{{ marca }} {{ modelo }}</span>
            </div>
            <div class="versionColorKm versionColorKm-aux">{{ version }} <span class="pipe">|</span> {{ color }} <span
                class="pipe">|</span> {{ formatPrice(kilometraje) }} KM</div>

            <div class="nofolio">
              <h4 class="titulo-nofolio">NO. DE OFERTA: {{ folio }}</h4>
              <h4 class="titulo-nofolio marginTop-folio">NO. DE INSPECCIÓN AGENDADA: {{ folioMail }}</h4>






            </div>

            <div class="col-1">&nbsp;</div>

            <div class="oferta-wrpr col-10 justify-content-center">
              <h4 class="mejor-oferta">EL RANGO DE TU <br> MEJOR OFERTA <b>GARANTIZADA</b> ES</h4>
              <b-col>
                <h5 class="oferta"> <span class="ofertaLight">DE</span> ${{ formatPrice(formatValue(this.ofertaMin)) }}.00* <span
                    class="ofertaLight">A</span> ${{ formatPrice(formatValue(this.ofertaMax)) }}.00*</h5>
              </b-col>
            </div>
            <div class="col-1">&nbsp;</div>
            <br />
            <br />

            <div class="margin-oferta1 col-md-12 text-center mt-3">
              <p class="texto-oferta">
                Esta oferta es válida hasta el <strong>{{ this.validezVA }}</strong><br />*La oferta puede variar
                después
                de la inspección del vehículo
              </p>

              <div v-if="this.tipoInspeccion !== 'domicilio'" class="row justify-content-md-center">
                <div class="row col-12">
                  <div class="col-6 right-2">
                    <h3 class="info-cita">Fecha:</h3>
                  </div>
                  <div class="col-6 left-2">
                    <h3 class="info-cita-2">{{this.fecha}}</h3>
                  </div>
                  <div class="col-6 right-2">
                    <h3 class="info-cita">Hora:</h3>
                  </div>
                  <div class="col-6 left-2">
                    <h3 class="info-cita-2">{{this.hora}} hrs.</h3>
                  </div>
                  <div class="col-6 right-2">
                    <h3 class="info-cita">Lugar de inspección:</h3>
                  </div>
                  <div class="col-6 left-2">
                    <h3 class="info-cita-2">{{this.agencia}} <br> {{this.domicilio}}</h3>
                  </div>
                </div>
              </div>

              <div v-if="this.tipoInspeccion === 'domicilio'" class="row col-12">
                <div class="col-6 right-2">
                  <h3 class="info-cita">Domicilio donde te visitaremos:</h3>
                </div>
                <div class="col-6 left-2">
                  <h3 class="info-cita-2"><span>{{this.domicilio}}</span></h3>
                </div>
              </div>

              <p class="textoagendar">Para reagendar primero elige donde quieres que se realice la inspección.</p>
            </div>
            <br />

            <div class="col-12 desktop" style="">
              <div class="row" style="margin-top: -25px;">
                <div class="col-6 right-2">
                  <button type="button" class="btn-agencia" @click.prevent="agendarAgencia()"><img class="btn-img-dom"
                      src="../assets/imgs/btn_agencia_on.png" /></button>
                </div>
                <div class="col-6 left-2">
                  <button type="button" class="btn-domicilio" @click.prevent="agendarDomicilio()"><img
                      class="btn-img-dom" src="../assets/imgs/btn_domicilio_on.png" /></button>
                </div>
              </div>
            </div>


          </div>

          <!-- No Oferta -->
          <div v-if="this.noOferta === true" class="row text-center info-auto-oferta">

            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">OFERTA NO VALIDA</div>

                <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  La oferta ingesada ya no es vigente <br> recuerda que las ofertas tienen una validez de 8 días
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="nuevaOferta()">
                    NUEVA OFERTA
                  </button>
                </div>
              </div>
            </b-row>
          </div>

          <!-- No Encontrado -->
          <div v-if="this.noEncontrado === true" class="row text-center info-auto-oferta">

            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">FOLIO NO ENCONTRADO</div>

                <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  El folio ingesado no se encuentra <br> en nuestro sistema, intenta con un folio valido
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="nuevaOferta()">
                    NUEVA OFERTA
                  </button>
                </div>
              </div>
            </b-row>
          </div>

          <!-- No en Seguimiento -->
          <div v-if="this.enSeguimiento === true" class="row text-center info-auto-oferta">

            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">OFERTA EN SEGUIMIENTO</div>

                <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  Un asesor ya ha tomado la Oferta para darle seguimiento, <br> en breve se contactará contigo.
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="nuevaOferta()">
                    NUEVA OFERTA
                  </button>
                </div>
              </div>
            </b-row>
          </div>

          <b-modal v-model="modalErrorConexion" size="lg" style="width: 100%" hide-header hide-footer>
            <b-row cols="1" class="content-modal justify-content-md-center">

              <div class="col-sm-12 text-center">
                <div class="modal-title mt-5">ERROR EN NUESTRO SISTEMA</div>

                <img class="ico-inspeccion" src="../assets/imgs/error_varios_icon.svg" alt="AUTOCOM" />

                <div class="lamentamos mt-3">
                  Nuestro servicio está presentando errores, por el<br> momento no es posible realizar la operación,
                  inténtalo <br> más tarde.
                </div>
              </div>

              <div class="text-center mt-4">
                <div class="controls">
                  <button class="" @click.prevent="cerrarModal()">
                    CERRAR
                  </button>
                </div>
              </div>
            </b-row>
          </b-modal>

        </div>
      </div>
    </div>

    <b-modal v-model="modalnoValido" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">

        <div class="col-sm-12 text-center">
          <div class="modal-title mt-5">OFERTA NO VALIDA</div>

          <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />

          <div class="lamentamos mt-3">
            La oferta ingesada ya no es vigente <br> recuerda que las ofertas tienen una validez de 8 días
          </div>
        </div>

        <div class="text-center mt-4">
          <div class="controls">
            <button class="" @click.prevent="cerrarModal()">
              CERRAR
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

    <b-modal v-model="modalCancelacion" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="justify-content-md-center">

        <div class="col-sm-12 text-center">
          <div class="modal-title mt-5">¡Tenemos el mejor precio del mercado, garantizado!</div>
          <div class="lamentamos mt-3">
            Si tiene alguna duda seguro podemos ayudarte, llámanos al <a href="tel:800711286">800 711 286</a> o manda un
            mensaje de Whatsapp al <a href="
            https://wa.me/+524434911681?text=Hola">443 491 1681</a>
          </div>
          <div class="lamentamos mt-3">
            Selecciona el motivo de la cancelación y un asesor se pondrá en <br>
            contacto contigo para ayudarte.
          </div>

          <div class="motivoTextSelect text-left mt-4">
            <h5 class="texto-vehiculoModal">Motivo de la cancelación</h5>
            <select class="motivos">
              <option selected disabled value="">Selecciona una opción</option>
              <option value="">Deseo pensarlo mejor</option>
              <option value="">No encuentro el modelo que tengo</option>
              <option value="">Encontré una mejor oferta</option>
              <option value="">Prefiero acudir a la agencia</option>
              <option value="">No vendere mi automóvil en este momento</option>
              <option value="">No quiero quedarme sin automóvil</option>
              <option value="">Otro</option>
            </select>

          </div>
        </div>

        <div class="text-center mt-4">
          <div>
            <button class="btn-confirm-m" @click.prevent="cerrarCancelar()">
              CONTINUAR CON LA INSPECCIÓN
            </button>
          </div>
          <div>
            <button class="btn-resend-m" @click.prevent="cancelarSolicitud()">
              CANCELAR LA SOLICITUD
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
export default {


  name: "Oferta",

  components: {},

  data() {
    return {

      
      // server: 'https://srv-autocheck.autocomseminuevos.com/api',

     
     
      // serverAnalizador: 'https://qa-api-analizador.autocom.mx/api',
      //server: 'https://dev-srv-valoraciones.autocom.mx/api',


      /*serverAnalizador: 'https://qa-api-analizador.autocom.mx/api',
      serverAutoCheck: 'https://qa-api-autocheck.autocom.mx/api',
      creatioService: 'https://qa-creatioservice.autocom.mx/api',
      serverComunicaciones: 'https://qa-comunicaciones.autocom.mx/api',*/

      serverAnalizador: process.env.VUE_APP_SERVER_ANALIZADOR,
      serverAutoCheck: process.env.VUE_APP_SERVER_AUTOCHECK,

      creatioService: process.env.VUE_APP_CREATIO_SERVICE,

      serverComunicaciones: process.env.VUE_APP_SERVER_COMUNICACIONES,


      marca: "",
      modelo: "",
      año: "",
      ofertaVa: "",
      ofertaMin: "",
      ofertaMax: "",
      folio: "",
      version: "",
      color: "",
      kilometraje: "",
      validezVA: "",
      folioMail: "",
      modalTipoV: false,
      modalCancelacion: false,
      modalnoValido: false,
      modalErrorConexion: false,
      nombre: "",
      apellidos:  "",
      tipoInspeccion: "",
      fecha: "",
      hora: "",
      agencia: "",
      domicilio: "",
      seguimiento: "",

      oferta: false,
      noOferta: false,
      noEncontrado: false,
      enSeguimiento: false,

    };
  },

  methods: {

    tokenComunicaciones() {
      let user = { usuario: "Comunicaciones", password: "C0mun1c4c10n35" };
      axios.post(this.serverComunicaciones + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenComunicacion", response.data.token);
        }).catch((error) => {
          this.mensajeError1 = 'ECOTK';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones ...', error.message)
        });
    },

    snifferError(error, servicio) {

      let data = {
        error: error,
        servicio: servicio,
      }


      axios.post(this.serverComunicaciones + "/snifferVa", data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          console.log('Alerta enviada');
        })
        .catch((error) => {
          console.log('Error de alerta --->', error);
        });

    },

    cargarToken() {
      let user = { usuario: "autocom_seminuevos", password: "invarart2022Semi" };
      axios
        .post(this.serverAutoCheck + "/auth", user)
        .then((response) => {
          sessionStorage.setItem("tokenIntelimotor", response.data.token);
          this.validaFolio();
        }).catch((error) => {
          this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });
    },


    agendar() {
      this.modalTipoV = true;
    },

    cancelar() {
      this.modalCancelacion = true;
    },

    cerrar() {
      this.modalTipoV = false;
    },

    cerrarCancelar() {
      this.modalCancelacion = false;
    },

    async cancelarSolicitud() {
      this.modalCancelacion = false;
      setTimeout(() => {
        this.$router.push({ path: "/" });
      }, 150);
    },

    async cerrarModal() {

    this.noOferta = true;
    this.oferta = false;
    this.modalnoValido = false;
    this.modalErrorConexion = false;

    },

    async nuevaOferta() {
    setTimeout(() => {
      this.$router.push({ path: "/" });
    }, 150);
    },

    async agendarAgencia() {
      this.modalTipoV = false;
      clearTimeout(this.intervalos);
        setTimeout(() => {
          this.$router.push({ path: "/Reagendar" });
        }, 150);
      sessionStorage.setItem("tipoInspeccion", "agencia");
    },

    async agendarDomicilio() {
      this.modalTipoV = false;
      clearTimeout(this.intervalos);
        setTimeout(() => {
          this.$router.push({ path: "/Reagendar" });
        }, 150);
      sessionStorage.setItem("tipoInspeccion", "domicilio");
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatValue(value) {
      let val = Math.round(value / 100) * 100;
      return val
    },

    validaFolio() {

      this.folioMail = this.$route.query.vafolio;

      if (this.folioMail !== undefined ) {
        console.log('Folio --->',this.folioMail);

        this.validaAgendamiento();

      } else {
        console.log('Oferta True');
        
        this.noOferta = false;
        this.oferta = true;
        this.noEncontrado = false;
        this.enSeguimiento = false;
        this.modalnoValido = false;
      }
    },

    validaAgendamiento() {

      let body = { folio: this.$route.query.vafolio,
            telefono: this.telefono
            };

      axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          //console.log('response -->',response.data.data);

          if (response.data.status === 204) {

            this.noOferta = false;
            this.oferta = false;
            this.noEncontrado = true;
            this.enSeguimiento = false;
            this.modalnoValido = false;

          } else if (response.data.data[0].para_reagendamiento === "No") {

            this.noOferta = false;
            this.oferta = false;
            this.noEncontrado = false;
            this.enSeguimiento = true;
            this.modalnoValido = false;

          } else {

            this.validaVigencia();

          }

        })
        .catch((error) => {
          this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.errorvaloracion = true;
          console.log(error.response.status);

          if (error.response.status === 400) {
            this.noOferta = false;
            this.oferta = false;
            this.noEncontrado = true;
            this.enSeguimiento = false;
            this.modalnoValido = false;
          } else {
            this.modalErrorConexion = true;
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
          }
        });

    },

    validaVigencia() {

    this.folioMail = this.$route.query.vafolio;

    let body = { folio: this.folioMail,
        telefono: ''
        };

    axios.post(
      this.serverAutoCheck + "/calendario/valoracion_agendamiento",
      body,
      {
        headers: {
          Authorization:
            "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {

        const date = new Date();
        // const output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
        const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
          const dia = new Date(output).getTime();
          const diac = Math.round(dia/(1000*60*60*24));

        this.diaActual = output;
        this.diaVigencia = response.data.data[0].vigencia_oferta.substring(0,2);
        this.mesVigencia = response.data.data[0].vigencia_oferta.substring(3,5);
        this.anioVigencia = response.data.data[0].vigencia_oferta.substring(6,10);
        this.fechaVigencia = this.anioVigencia+'-'+this.mesVigencia+'-'+this.diaVigencia;
        const dia2 = new Date(this.fechaVigencia).getTime();
        const diac2 = Math.round(dia2/(1000*60*60*24));

        console.log('Días --> día 1:',diac+' - día 2:'+diac2+' - Folio:'+this.folioMail);

        if (diac > diac2) {

          this.noOferta = true;
          this.oferta = false;
          this.noEncontrado = false;
          this.enSeguimiento = false;
          this.modalnoValido = true;


        } else {

          this.validaInfoFolio();

        }
    })
    .catch((error) => {
      // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
      // this.errorvaloracion = true;
      this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
    });

    },

    /*tokenCreatio() {

      if (this.seguimiento === 'creatio') {
        
        let user = {usuario: "CreatioService", password: "Cr34t1053rv1c3"};
        axios.post(this.creatioService + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenCreatio", response.data.token);
          this.consultaCreatio();
        })
        .catch((error) => {
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
        });

      } else {
        console.log('Cliente atendido por asesor');
      }
      
    },*/

    /*consultaCreatio(){

    console.log('Consulta Creatio');

    this.idAutocheck = this.$route.query.vafolio;

    axios.get(this.creatioService + '/loadIdCreatio/'+this.idAutocheck,  
      {
        headers: {
          Authorization:
            "Bearer " + sessionStorage.getItem("tokenCreatio"),
          "Content-Type": "application/json",
        },
      })
    .then(response =>{
      //console.log('Respuesta -->',response);
      sessionStorage.setItem("IdCreatio", response.data[0].idcreatio);
      sessionStorage.setItem("nombre", response.data[0].nombre);
      sessionStorage.setItem("apellidos", response.data[0].apellidos);
      this.nombre = sessionStorage.getItem("nombre");
      this.apellidos = sessionStorage.getItem("apellidos");
    }).catch(error=>{
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
    });

    },*/

    validaInfoFolio() {

    this.folioMail = this.$route.query.vafolio;      

    let body = { folio: this.folioMail,
          telefono: ''
          };

    axios.post(
      this.serverAutoCheck + "/calendario/valoracion_agendamiento",
        body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {

        this.agendamiento = response.data.data[0].tiene_agendamiento;
        console.log('Respuesta -->', this.agendamiento);
        this.modalnoValido = false;
        this.noOferta = false;

        if (this.agendamiento === 0) {

            clearTimeout(this.intervalos);

            setTimeout(() => {
              this.$router.push({ path: "/Oferta?vafolio="+this.$route.query.vafolio });
            }, 150);

        } else {

          if (response.data.data[0].tipo_agendamiento === 'agencia') {
            console.log('Agencia');
            sessionStorage.setItem("tipoInspeccion", response.data.data[0].tipo_agendamiento);
            sessionStorage.setItem("idcliente", response.data.data[0].id_cliente);
            sessionStorage.setItem("email", response.data.data[0].email);
            sessionStorage.setItem("telefono", response.data.data[0].telefono);
            sessionStorage.setItem("folio", response.data.data[0].folioVA);
            sessionStorage.setItem("idvaloration", response.data.data[0].folio);
            sessionStorage.setItem("oferta", response.data.data[0].oferta);
            sessionStorage.setItem("offer_day", response.data.data[0].oferta_hoy);
            sessionStorage.setItem("offer_consignment", response.data.data[0].oferta_consignacion);
            sessionStorage.setItem("marca", response.data.data[0].marca);
            sessionStorage.setItem("modelo", response.data.data[0].modelo);
            sessionStorage.setItem("anio", response.data.data[0].year);
            sessionStorage.setItem("version", response.data.data[0].trim);
            sessionStorage.setItem("color", response.data.data[0].ext_color);
            sessionStorage.setItem("kilometraje", response.data.data[0].kilometers);
            sessionStorage.setItem("fecha_validez", response.data.data[0].vigencia_oferta.substring(0,10));
            sessionStorage.setItem("fechaAgendamiento", response.data.data[0].fecha_calendario.substring(0,10));
            sessionStorage.setItem("horaAgendamiento", response.data.data[0].hora);
            sessionStorage.setItem("direccionAgendamiento", response.data.data[0].domicilio_agendamiento);
            sessionStorage.setItem("sucursalAgendamiento", response.data.data[0].sucursal_agendamiento);
            sessionStorage.setItem("precioSolicitado", response.data.data[0].precio_sugerido);
            this.fecha = sessionStorage.getItem("fechaAgendamiento");
            this.hora = sessionStorage.getItem("horaAgendamiento");
            this.domicilio  = sessionStorage.getItem("direccionAgendamiento");
            this.agencia = sessionStorage.getItem("sucursalAgendamiento");
            this.tipoInspeccion = sessionStorage.getItem("tipoInspeccion");
            this.marca = sessionStorage.getItem("marca");
            this.modelo = sessionStorage.getItem("modelo");
            this.año = sessionStorage.getItem("anio");
            this.ofertaVa = sessionStorage.getItem("oferta");
            this.folio = sessionStorage.getItem("folio");
            this.version = sessionStorage.getItem("version");
            this.color = sessionStorage.getItem("color");
            this.kilometraje = sessionStorage.getItem("kilometraje");
            this.validezVA = sessionStorage.getItem("fecha_validez");
            sessionStorage.setItem("tipoAgendamiento", 'reagendamiento');

            this.ofertaMin = (this.ofertaVa - (this.ofertaVa * .10));
            //this.ofertaMax = (Number(this.ofertaVa) + (this.ofertaVa * .02));
            this.ofertaMax = this.ofertaVa;

              if (this.seguimiento !== 'creatio') {
                sessionStorage.setItem("nombre", response.data.data[0].cliente);
                this.nombre = sessionStorage.getItem("nombre")
              } else {
                console.log('Nombre por creatio')
              }

            this.noOferta = false;
            this.noEncontrado = false;
            this.enSeguimiento = false;
            this.modalnoValido = false;
            this.oferta = true;
          } else {
            console.log('Domicilio');
            sessionStorage.setItem("tipoInspeccion", response.data.data[0].tipo_agendamiento);
            sessionStorage.setItem("idcliente", response.data.data[0].id_cliente);
            sessionStorage.setItem("email", response.data.data[0].email);
            sessionStorage.setItem("telefono", response.data.data[0].telefono);
            sessionStorage.setItem("folio", response.data.data[0].folioVA);
            sessionStorage.setItem("idvaloration", response.data.data[0].folio);
            sessionStorage.setItem("oferta", response.data.data[0].oferta);
            sessionStorage.setItem("offer_day", response.data.data[0].oferta_hoy);
            sessionStorage.setItem("offer_consignment", response.data.data[0].oferta_consignacion);
            sessionStorage.setItem("marca", response.data.data[0].marca);
            sessionStorage.setItem("modelo", response.data.data[0].modelo);
            sessionStorage.setItem("anio", response.data.data[0].year);
            sessionStorage.setItem("version", response.data.data[0].trim);
            sessionStorage.setItem("color", response.data.data[0].ext_color);
            sessionStorage.setItem("kilometraje", response.data.data[0].kilometers);
            sessionStorage.setItem("fecha_validez", response.data.data[0].vigencia_oferta.substring(0,10));
            sessionStorage.setItem("direccionAgendamiento", response.data.data[0].domicilio_agendamiento);
            sessionStorage.setItem("precioSolicitado", response.data.data[0].precio_sugerido);
            this.tipoInspeccion = sessionStorage.getItem("tipoInspeccion");
            this.domicilio  = sessionStorage.getItem("direccionAgendamiento");
            this.marca = sessionStorage.getItem("marca");
            this.modelo = sessionStorage.getItem("modelo");
            this.año = sessionStorage.getItem("anio");
            this.ofertaVa = sessionStorage.getItem("oferta");
            this.folio = sessionStorage.getItem("folio");
            this.version = sessionStorage.getItem("version");
            this.color = sessionStorage.getItem("color");
            this.kilometraje = sessionStorage.getItem("kilometraje");
            this.validezVA = sessionStorage.getItem("fecha_validez");
            sessionStorage.setItem("tipoAgendamiento", 'reagendamiento');

            this.ofertaMin = (this.ofertaVa - (this.ofertaVa * .10));
            //this.ofertaMax = (Number(this.ofertaVa) + (this.ofertaVa * .02));
            this.ofertaMax = this.ofertaVa;

              if (this.seguimiento !== 'creatio') {
                sessionStorage.setItem("nombre", response.data.data[0].cliente);
                this.nombre = sessionStorage.getItem("nombre")
              } else {
                console.log('Nombre por creatio')
              }

            this.noOferta = false;
            this.noEncontrado = false;
            this.enSeguimiento = false;
            this.modalnoValido = false;
            this.oferta = true;
          }
          
        }
      })
      .catch((error) => {
        // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
        // this.errorvaloracion = true;
        this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones 123 ...', error.message);
      });

    },

    opendWindow(){
      clearInterval(this.intervalos);
      window.location.replace('/');
      //console.log('1');
    },

    tiempoActivo(){
      this.intervalos = setInterval(() => {
        this.opendWindow();
      },3600000);
    }

  },

  created() {
    window.scrollTo(0, 0);
    if (this.$route.query.seguimiento === undefined || this.$route.query.seguimiento === null || this.$route.query.seguimiento === '') {
      this.seguimiento = sessionStorage.getItem("seguimiento");
      console.log('seguimiento 1 --->', this.seguimiento);
    } else {
      this.seguimiento = this.$route.query.seguimiento;
      sessionStorage.setItem("seguimiento", this.seguimiento)
      console.log('seguimiento 2 --->', this.seguimiento);
    }
    this.tokenComunicaciones();
    this.cargarToken();
    //this.tokenCreatio();
    this.tiempoActivo();
 
  },


  onMounted(){
    window.scrollTo(0, 0)
  }
};
</script>

<style>

</style>
